module.exports = __webpack_public_path__ + "static/media/fireplace1.149ea4bb.png";